import { render } from "./EnrollMobileView.vue?vue&type=template&id=2d5edd66"
import script from "./EnrollMobileView.vue?vue&type=script&lang=js"
export * from "./EnrollMobileView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__